import { useState } from "react"

/**
 * Custom hook for managing modal states
 * @returns {Object} Modal states and handlers
 */
export const useUserModals = () => {
  const [userDetailsModal, setUserDetailsModal] = useState({ isOpen: false, user: null })
  const [devicesModal, setDevicesModal] = useState({ isOpen: false, user: null })
  const [credentialsModal, setCredentialsModal] = useState({ isOpen: false, user: null })
  const [restoreModal, setRestoreModal] = useState(false)
  const [deleteConfirmModal, setDeleteConfirmModal] = useState({
    isOpen: false,
    userCount: 0,
    isBulk: false,
    onConfirm: null
  })
  const [createUserModal, setCreateUserModal] = useState(false)

  const handleViewUser = (user) => {
    setUserDetailsModal({ isOpen: true, user })
  }

  const handleViewDevices = (user) => {
    setDevicesModal({ isOpen: true, user })
  }

  const handleViewCredentials = (user) => {
    setCredentialsModal({ isOpen: true, user })
  }

  const closeUserDetailsModal = () => {
    setUserDetailsModal({ isOpen: false, user: null })
  }

  const closeDevicesModal = () => {
    setDevicesModal({ isOpen: false, user: null })
  }

  const closeCredentialsModal = () => {
    setCredentialsModal({ isOpen: false, user: null })
  }

  const closeDeleteConfirmModal = () => {
    setDeleteConfirmModal({ isOpen: false, userCount: 0, isBulk: false, onConfirm: null })
  }

  return {
    // Modal states
    userDetailsModal,
    devicesModal,
    credentialsModal,
    restoreModal,
    deleteConfirmModal,
    createUserModal,

    // Setters
    setUserDetailsModal,
    setDevicesModal,
    setCredentialsModal,
    setRestoreModal,
    setDeleteConfirmModal,
    setCreateUserModal,

    // Handlers
    handleViewUser,
    handleViewDevices,
    handleViewCredentials,
    closeUserDetailsModal,
    closeDevicesModal,
    closeCredentialsModal,
    closeDeleteConfirmModal
  }
}
